import React from "react"
import { useController } from "react-hook-form"
import {
  Box,
  Alert,
  TextField,
  FormControl,
  FormLabel,
} from "@fedsim/components"
import { Controller } from "react-hook-form"
import { FormError } from "./error"
import { SPACING } from '@fedsim/constants'

export const FormText = ({
  defaultValue = "",
  name,
  control,
  label,
  size = "small",
  fullWidth = true,
  variant = "filled",
  type = "text",
  // rules = { required: true },
  // rules={rules}
}) => {
  return (
    <Controller
      defaultValue={defaultValue}
      name={name}
      control={control}
      render={values => {
        const {
          fieldState: { error },
          field: { onChange, value = null },
        } = values
        // const helperText = errors?.[name]?.type ? errors?.[name]?.type : false

        const helperText = error?.type
        return (
          <FormControl fullWidth component='fieldset'>
            <FormLabel>{label}</FormLabel>
            <TextField
              fullWidth={fullWidth}
              variant={variant}
              type={type}
              size={size}
              error={error}
              helperText={helperText}
              onChange={onChange}
              onBlur={onChange}
              value={value}
              name={name}
            />
            {error?.type && <FormError type={error.type} />}
          </FormControl>
        )
      }}
    />
  )
}

export const FormNumber = props => FormText({ type: "number", ...props })

export const FormImage = props => {
  const {
    field: { value },
  } = useController(props)
  return (
    <>
      <FormText {...props} />
      <Box mb={SPACING}>
        <Alert severity='info' icon={false}>
          FedSim does not store images, you must provide urls to the third party
          image
        </Alert>
      </Box>
      {value && (
        <Box>
          <Alert severity='info' icon={false}>
            <img src={value} style={{ maxWidth: "25vw" }} alt='' title='' />
          </Alert>
        </Box>
      )}
    </>
  )
}
